import mutations from './mutations'
import actions from './actions'
import getters from './getters'

const state = {
	protocol: null,
	selectedAmendment: null,
	amendments: [],
	researcher: null,
	assignedReviewers: [],
	reviewers: [],
	dictums: [],
	dates: [],
	committeeDictums: [],
	financingCommitments: [],
	dictumTypes: [],
	readonly: false,
	funders: [],
	researchers: [],
	externalResearchers: [],
}

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters,
}
